import { render, staticRenderFns } from "./RouteDeviationTable.vue?vue&type=template&id=814c94fa"
import script from "./RouteDeviationTable.vue?vue&type=script&lang=js"
export * from "./RouteDeviationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports